import { AxiosResponse } from 'axios'
import api from '~/services/api'

export const sendTransferContactService = async (numberPhone: string) => {
  const res: AxiosResponse<{ success: boolean }> = await api.post('/analytics/provide-contact', {
    phone: numberPhone
  })
  return res
}
